export class StudyDetail {
    constructor(
        lesson,
        time,
        attendance,
        rating,
        homeworkStatus,
        comments,
        commentPhase,
        type,
        totalLesson,
        studentFeedback,
        autoComment,
        attendanceReason,
        scheduleType,
        capacityBuilding,
        tooltip,
        type_comment_phase,
        version, classroom_id, end_course_assessment = null) {
        this.lesson = lesson;
        this.time = time;
        this.attendance = this.attendanceToString(attendance)
        this.rating = rating;
        this.homeworkStatus = homeworkStatus
        this.comments = comments
        this.commentPhase = commentPhase
        this.type = type
        this.studentFeedback = studentFeedback
        this.autoComment = autoComment
        this.scheduleType = scheduleType
        this.capacityBuilding = capacityBuilding
        this.tooltip = tooltip
        this.type_comment_phase = type_comment_phase
        this.version = version
        this.classroom_id = classroom_id
        this.end_course_assessment = end_course_assessment
    }
    attendanceToString (item) {
        switch (item) {
            case 0:
                return 'Vắng mặt';
            case 1:
                return 'Có mặt';
            case 2:
                return 'Có phép';
            case 3:
                return 'Ngừng học';
            default:
                return null
        }
    }
}


